import React, { Component } from 'react';

import NAV from '../../lib/navigation';
import AppActions from '../../lib/flux/AppActions'
import AppActionTypes from '../../lib/flux/AppActionTypes'
import AppStore from '../../lib/flux/AppStore';

import './Intro.scss'
import Crossfade from '../../components/Crossfade';
import Dots from '../../components/Dots';
import ReAnimation from '../../components/ReAnimation/ReAnimation';
import { TweenLite } from 'gsap';

import { isMobile } from '../../lib/common'

class Intro extends Component {

    constructor(props) {
        super(props);
        this.state = {
            intro: AppStore.getAnimations().intro
        }
    }

    componentDidMount() {
        AppStore.on(AppActionTypes.ANIMATION, this._handleStoreAnimationChange);
        
    }

    componentWillUnmount() {
        AppStore.removeListener(AppActionTypes.ANIMATION, this._handleStoreAnimationChange);
    }

    _handleStoreAnimationChange = ({ intro }) => {
        // console.log('_handleStoreAnimationChange', { intro });
        this.setState({ intro });
        
        if (intro) {
            this.in();
        }
    }

    in = () => {
        TweenLite.to(this.refs.links, 1, {opacity: 1, ease: 'easeInOutQuart'})
    }


    render() {
        const { intro } = this.state;

        return (
            <div className={'intro-container'}>

                <div className="logo">
                    <ReAnimation intro={!intro} />
                </div>

                <Crossfade />

                {/* <div className={`intro-link-container ${intro ? '' : 'hidden'}`}> */}
                <div className={`intro-link-container`} ref="links">
                    <div className={'intro-link left'} onClick={() => { AppActions.navigation({ location: NAV.THEME, back: NAV.INTRO }) }}>
                        <div className={'link'}>
                            {
                                // isMobile() ? 'Discover The Theme' : 'Discover The Theme'
                                isMobile() ? '2019 Theme' : 'Discover The Theme'
                            }
                        </div>

                    </div>
                    <div className={'intro-link right'} onClick={() => { AppActions.navigation({ location: NAV.LINEUP, back: NAV.INTRO }) }}>
                        <div className={'link'}>
                            {'Speakers / Performers'}
                        </div>

                    </div>
                </div>
            </div >
        );
    }
}

export default Intro;